export const DOMAIN = process.env.REACT_APP_DOMAIN || '';
export const BASE_URL = process.env.REACT_APP_BASE_URL || '';
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || '';
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';
export const IS_BASIC_AUTH_ENABLED = Boolean(process.env.REACT_APP_IS_BASIC_AUTH_ENABLED);
